import React from "react";
import { useLoginVM } from "../viewmodels/LoginVM";
import LoginView from "../views/LoginView";

const LoginPage: React.FC = () => {
    const vm = useLoginVM();

    return <div>
        <LoginView
            form={vm.form}
            errorMessages={vm.errorMessages}
            onValueChange={vm.setField}
            submit={vm.submit}
            loading={vm.loading}
            showConfirm={vm.showConfirm}
            setShowConfirm={vm.setShowConfirm}
        />
    </div>;
};

export default LoginPage;